import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { TODAY } from 'constants/dateLimits';
import {
  setToStartOfMonth,
  getApplicantRequiredDuration,
  getSafeDateTime
} from 'helpers/date';
import { SubstanceDrugsSupplementalUsageItemModel } from '../types';

const substanceDrugsSupplementalUsageItemValidator: ValidateJSModel<SubstanceDrugsSupplementalUsageItemModel> = {
  DrugUsed: { presence: true, hasValue: true },
  DateRange: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;
    const { coverage } = getApplicantRequiredDuration({
      requiredDuration: { years: 5 },
      applicantBirthdate,
      thresholdYears: 16,
      minimumYears: 0,
    });

    const toDate = getSafeDateTime(value?.to);
    const requiredDate = setToStartOfMonth(getSafeDateTime(TODAY.minus(coverage)));
    const beyondRequired = (toDate.valid && requiredDate.valid) ? (toDate?.datetime < requiredDate?.datetime) : false;

    return {
      presence: true,
      daterange: {
        requireYear: false,
        earliest: beyondRequired ? requiredDate.datetime : applicantBirthdate,
        latest: DEFAULT_LATEST,
        tooEarly: beyondRequired ? 'error.beforeDuration' : 'error.applicantMin',
      },
    };
  },
  NumberOfTimesUsed: { presence: true, hasValue: true },
  Comment: {}
};

export default substanceDrugsSupplementalUsageItemValidator;
